import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { MobileNumberForFrenchLeader } from '../../../lib/types/models/ol/mobile-number-for-french-leader/mobile-number-for-french-leader'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

type GetMobileNumberForFrenchLeadersRequest = PaginationRequest & { olId: number }

export function getMobileNumberForFrenchLeaders(input: GetMobileNumberForFrenchLeadersRequest) {
  const { olId, ...paginationQuery } = input

  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.ols.getMobileNumberForFrenchLeaders.url, { olId }),
        paginationQuery
      )
    )
    .get<PaginationResponse<MobileNumberForFrenchLeader>>()
}
